/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CashExposureType = {
    FEE: 'fee',
    BUFFER: 'buffer',
    AD_HOC_WITHDRAWAL: 'ad_hoc_withdrawal',
    PLANNED_WITHDRAWAL: 'planned_withdrawal',
    UNENCUMBERED: 'unencumbered'
} as const;
export type CashExposureType = typeof CashExposureType[keyof typeof CashExposureType];


export function instanceOfCashExposureType(value: any): boolean {
    for (const key in CashExposureType) {
        if (Object.prototype.hasOwnProperty.call(CashExposureType, key)) {
            if (CashExposureType[key as keyof typeof CashExposureType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function CashExposureTypeFromJSON(json: any): CashExposureType {
    return CashExposureTypeFromJSONTyped(json, false);
}

export function CashExposureTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): CashExposureType {
    return json as CashExposureType;
}

export function CashExposureTypeToJSON(value?: CashExposureType | null): any {
    return value as any;
}

export function CashExposureTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): CashExposureType {
    return value as CashExposureType;
}

